import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { cn } from '../../lib/cn';
const WordSlider = ({ reducedMotionText, words }) => {
    const prefersReducedMotion = useReducedMotion();
    const [currentWordIndex, setCurrentWordIndex] = useState(0);
    const [animateIn, setAnimateIn] = useState(false);
    const [animateOut, setAnimateOut] = useState(false);
    useEffect(() => {
        if (words.length === 0) {
            setCurrentWordIndex(0);
            setAnimateIn(false);
            setAnimateOut(false);
            return;
        }
        setCurrentWordIndex((previousIndex) => Math.min(previousIndex, words.length - 1));
    }, [words.length]);
    useEffect(() => {
        if (prefersReducedMotion || words.length === 0)
            return;
        let pendingTimeout = null;
        const interval = setInterval(() => {
            setAnimateOut(true);
            pendingTimeout = setTimeout(() => {
                setAnimateOut(false);
                setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
                setAnimateIn(true);
            }, 1000);
        }, 3000);
        return () => {
            clearInterval(interval);
            if (pendingTimeout !== null)
                clearTimeout(pendingTimeout);
        };
    }, [prefersReducedMotion, words]);
    useEffect(() => {
        if (prefersReducedMotion)
            return;
        if (animateIn) {
            const timer = setTimeout(() => {
                setAnimateIn(false);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [animateIn, prefersReducedMotion]);
    if (words.length === 0) {
        return _jsx("div", { className: "flex w-full items-center justify-center" });
    }
    if (prefersReducedMotion) {
        return (_jsx("div", { className: "flex w-full items-center justify-center", children: _jsx("span", { className: "text-emphasis text-text-accent", children: reducedMotionText ?? words[currentWordIndex] }) }));
    }
    return (_jsx("div", { className: "flex w-full items-center justify-center", children: _jsx("span", { className: cn('text-emphasis text-text-accent', animateIn && 'animate-slide-in', animateOut && 'animate-slide-out'), children: words[currentWordIndex] }) }));
};
export default WordSlider;
